import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "mfk-table",
  styleUrls: ["../dark-table.css", "./mfk.component.css"],
  template: `
<table class="mfkTable dark-table" [summary]="descriptions[highlightElement] ? 'Example of the ' + descriptions[highlightElement] + ' location in the MFK' : ''">
  <thead>
  <tr><th colspan="25">42 Character Master File Key</th></tr>
  </thead>
  <tbody>
  <tr>
    <td>&nbsp;&nbsp;&nbsp;</td>
    <td [class]="getTdClass('fund')">XXX</td>
    <td>-</td>
    <td [class]="getTdClass('org')">XX</td>
    <td>-</td>
    <td [class]="getTdClass('dept')">XXXX</td>
    <td>-</td>
    <td [class]="getTdClass('subdept')">XXXXX</td>
    <td>-</td>
    <td [class]="getTdClass('grantpgm')">X</td>
    <td>-</td>
    <td [class]="getTdClass('grantpgm')">XXXXXXX</td>
    <td>-</td>
    <td [class]="getTdClass('iact')">XXXX</td>
    <td>-</td>
    <td [class]="getTdClass('oact')">XXX</td>
    <td>-</td>
    <td [class]="getTdClass('dact')">XXXXX</td>
    <td>-</td>
    <td [class]="getTdClass('fn')">XX</td>
    <td>-</td>
    <td [class]="getTdClass('cctr')">XXXX</td>
    <td>-</td>
    <td [class]="getTdClass('brf')">XX</td>
    <td>&nbsp;&nbsp;&nbsp;</td>
  </tr>
  </tbody>
</table>
`
})
export class MfkTableComponent implements OnInit {
  @Input("highlight") highlightElement: string;

  descriptions = {
    fund: "Fund",
    org: "Org",
    dept: "Department",
    subdept: "Subdepartment",
    grandpgm: "Grant/Program ID",
    iact: "Institutional Account",
    oact: "Organizational Account",
    dact: "Departmental Account",
    fn: "Function",
    cctr: "Cost Center",
    brf: "Budget Reference Field"
  }

  constructor() { }

  getTdClass(chartfieldElement) {
    return this.highlightElement === chartfieldElement ? "highlight" : "";
  }

  ngOnInit() { }
}

